module.exports = __webpack_public_path__ + "static/img/options-clean.1770538668457.png";